<div class="page-container home-container">
    <p class="text">Quick Stocking Guide: <mat-icon fontIcon="info_outlined"></mat-icon></p>
    <div class="center-container">
        <div class="steps">
            <div class="step"><img src="/assets/images/icons/qrcode.svg" alt="">
                <div>Scan QR-Code to open the keybox.</div>
            </div>
            <div class="step"><img src="/assets/images/icons/input.svg" alt="">
                <div>Enter or select the number on the key.</div>
            </div>
            <div class="step"><img src="/assets/images/icons/hooks.svg" alt="">
                <div>Search for the moving hook.</div>
            </div>
            <div class="step"><img src="/assets/images/icons/key.svg" alt="">
                <div>Hang the key on the hook that moved.
                </div>
            </div>
            <div class="step"><img src="/assets/images/icons/success.svg" alt="">
                <div>Confirm that you hanged the key at the correct place.
                </div>
            </div>
        </div>
    </div>
    <div class="actions">
        <button mat-flat-button (click)="startApp()">Start Stocking</button>

    </div>
</div>